import { StyledProps } from '@front10';
import React from 'react';
import { useTranslation } from '@front10/utils';
import Box from '../../../elements/Box';
import { BoxProps } from '../../../elements/Box/Box';
import Icon from '../../../elements/Icon';
import { IconProps } from '../../../elements/Icon/Icon';
import Link from '../../../elements/Link';
import Text from '../../../elements/Text';

interface Props {
  showTitle?: boolean;
  showDescription?: boolean;
  /**
   * Define if it should show link to get directions
   */
  showLink?: boolean;
  /*
   * Define if it should show a link to a dedicated station page
   */
  showStationLink?: boolean;
  showCloseIcon?: boolean;
  data?: $TSFixMe;
  station: $TSFixMe;
  titleStyles?: BoxProps & TitleProps;
  descriptionStyles?: StyledProps;
  linkStyles?: StyledProps;
  closeIconStyles?: IconProps;
  onClose?: () => void;
  onStationClick?: (data: $TSFixMe, callToActionLabel: string) => void;
}

interface TitleProps {
  showLeftIcon?: boolean;
  showLabel?: boolean;
  leftIcon?: string;
  leftIconStyles?: IconProps;
  labelStyles?: StyledProps;
}

function LocationTooltip({
  showTitle = true,
  showDescription = true,
  showStationLink = true,
  showLink: showDirectionsLink = true,
  data: { title = '', description = '', link: directionsLink = '', stationLink = '' } = {},
  station = {},
  titleStyles: {
    showLeftIcon = false,
    showLabel = true,
    leftIcon,
    leftIconStyles,
    labelStyles = {
      fontWeight: 'bold'
    },
    ...titleStyles
  } = {},
  descriptionStyles = {},
  linkStyles = {
    textColor: 'primary',
    marginTop: '3',
    style: {
      textDecoration: 'underline'
    }
  },
  onStationClick,
  ...props
}: StyledProps<Props>) {
  const translate = useTranslation();
  return (
    <Box
      className="map-location-tooltip"
      position="relative"
      display="flex"
      flexDirection="column"
      alignItems="start"
      {...props}
    >
      {showTitle && (
        <Box display="flex" alignItems="center" {...titleStyles}>
          {showLeftIcon && <Icon icon={leftIcon} {...leftIconStyles} />}
          {showStationLink ? (
            <Link
              href={stationLink}
              {...labelStyles}
              onClick={() => onStationClick?.(station, 'map')}
            >
              {title}
            </Link>
          ) : (
            showLabel && <Text {...labelStyles}>{title}</Text>
          )}
        </Box>
      )}
      {showDescription && (
        <Box>
          <Text {...descriptionStyles}>{description}</Text>
        </Box>
      )}
      {showDirectionsLink && directionsLink && (
        <Link href={directionsLink} target="_blank" {...linkStyles}>
          {translate('cmp-bus-directory-map-directions', 'Get Directions')}
        </Link>
      )}
    </Box>
  );
}

export default LocationTooltip;
